import { LOGIN, SIGNUP, LOGOUT, HASSIGNED, CAMBIAR_CHANGELOG } from "../actions/user.js";

export const TAMANO_LETRA_TABLAS_DEFAULT = 11

const initialState = {
  isUserLoggedIn: false,
  tiempoSesion: 600000,
  usuarioId: null,
  usuarioPrincipal: null,
  nombre: null,
  apellidoPaterno: null,
  apellidoMaterno: null,
  tipo: null,
  permisos: [],
  mostrarChangelog: false,
  changelogVersion: null,
  headersToken: null,
  tamanoLetraTablas: TAMANO_LETRA_TABLAS_DEFAULT,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SIGNUP:
      return {
        isUserLoggedIn: true,
        tiempoSesion: action.data.tiempoSesion,
        usuarioId: action.data.usuarioId,
        usuarioPrincipal: action.data.usuarioPrincipal,
        nombre: action.data.nombre,
        apellidoPaterno: action.data.apellidoPaterno,
        apellidoMaterno: action.data.apellidoMaterno,
        tipo: action.data.tipo,
        permisos: action.data.permisos,
        mostrarChangelog: action.data.mostrarChangelog,
        changelogVersion: action.data.changelogVersion,
        headersToken: {
          "Content-Type": "application/json",
          "Authorization": action.data.jwt,
        },
        tamanoLetraTablas: action.data.tamanoLetraTablas || TAMANO_LETRA_TABLAS_DEFAULT,
      };

    case LOGIN:
      return {
        isUserLoggedIn: true,
        tiempoSesion: action.data.tiempoSesion,
        usuarioId: action.data.usuarioId,
        usuarioPrincipal: action.data.usuarioPrincipal,
        nombre: action.data.nombre,
        apellidoPaterno: action.data.apellidoPaterno,
        apellidoMaterno: action.data.apellidoMaterno,
        tipo: action.data.tipo,
        permisos: action.data.permisos,
        mostrarChangelog: action.data.mostrarChangelog,
        changelogVersion: action.data.changelogVersion,
        headersToken: {
          "Content-Type": "application/json",
          "Authorization": action.data.jwt,
        },
        tamanoLetraTablas: action.data.tamanoLetraTablas || TAMANO_LETRA_TABLAS_DEFAULT,
      };

      case HASSIGNED:
        return {
          isUserLoggedIn: true,
          tiempoSesion: action.data.tiempoSesion,
          usuarioId: action.data.usuarioId,
          usuarioPrincipal: action.data.usuarioPrincipal,
          nombre: action.data.nombre,
          apellidoPaterno: action.data.apellidoPaterno,
          apellidoMaterno: action.data.apellidoMaterno,
          tipo: action.data.tipo,
          permisos: action.data.permisos,
          mostrarChangelog: action.data.mostrarChangelog,
          changelogVersion: action.data.changelogVersion,
          headersToken: {
            "Content-Type": "application/json",
            "Authorization": action.data.jwt,
          },
          tamanoLetraTablas: action.data.tamanoLetraTablas || TAMANO_LETRA_TABLAS_DEFAULT,
        };

    case LOGOUT:
      return {
        isUserLoggedIn: false,
        tiempoSesion: 600000,
        usuarioId: null,
        usuarioPrincipal: null,
        nombre: null,
        apellidoPaterno: null,
        apellidoMaterno: null,
        tipo: null,
        permisos: [],
        mostrarChangelog: false,
        changelogVersion: null,
        headersToken: null,
        tamanoLetraTablas: TAMANO_LETRA_TABLAS_DEFAULT,
      };

    case CAMBIAR_CHANGELOG:
      return {
        ...state,
        mostrarChangelog: action.data.mostrarChangelog,
        changelogVersion: action.data.changelogVersion,
      };

    default:
      break;
  }
  return state;
};

export default reducer;
